import { useIntl } from "react-intl";
import { xaiDisconnectionResultColor } from "@lib/helpers/ColorHelper";
import { XAIDisconnectionResult } from "@lib/types/xAI";
import { AppTag } from "@lib/components/AppComponents";
import { darken } from "polished";

type Props = {
  result: XAIDisconnectionResult | string;
  size?: "small" | "default";
};

const XAIDisconnectionResultTag = (props: Props) => {
  const { result, size = "default" } = props;
  const { messages } = useIntl();

  const resultUpper =
    typeof result === "string" ? result.toUpperCase() : result;
  const resultSize = size === "small" ? 12 : 14;

  const color = xaiDisconnectionResultColor(resultUpper);

  return (
    <AppTag
      color={color}
      style={{
        fontSize: resultSize,
        borderColor: darken(0.3, color),
        borderWidth: 2,
        borderStyle: "solid",
      }}
    >
      {messages["enums.xaiDisconnectionResult"][resultUpper] ||
        messages["common.na"]}
    </AppTag>
  );
};

export default XAIDisconnectionResultTag;
